import { Flag } from "lucide-react";
import { useUnverifiedCircuits } from "@/lib/circuitStatus";

/** Small amber flag shown next to an unverified (user-added) circuit name. */
export default function CircuitFlag({ sport, name, className = "h-3 w-3 text-[#f59e0b] inline-block ml-1 align-[-1px]" }) {
    const unverified = useUnverifiedCircuits(sport);
    if (!name || !unverified.has(String(name).toLowerCase())) return null;
    return <Flag className={className} data-testid={`circuit-unverified-flag-${name}`} title="Unverified circuit — pending admin review" />;
}
